module.exports = __webpack_public_path__ + "media/images/flags/4x3/tza-259f5860c5d3159494a939b6b31ec32e.svg";